import React from "react";

const FilterLoading = () => {
  return (
    <div className="w-full lg:w-[300px] max-h-screen overflow-y-auto space-y-5 scrollbar-hide">
      <div className="border p-3 rounded-lg">
        <div>
          <div className="py-2 font-bold text-sm text-[#2155ad] capitalize bg-gradient-to-t from-blue-500 to-blue-900 bg-clip-text text-transparent">
            <div className="bg-slate-200 animate-pulse w-20 h-5"></div>
          </div>
        </div>
        <div>
          <div className="bg-slate-200 animate-pulse w-full h-8"></div>
        </div>
      </div>
      <div className="border p-3 rounded-lg">
        <div>
          <div className="py-2 font-bold text-sm text-[#2155ad] capitalize bg-gradient-to-t from-blue-500 to-blue-900 bg-clip-text text-transparent">
            <div className="bg-slate-200 animate-pulse w-20 h-5"></div>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-2">
          <div className="bg-slate-200 animate-pulse w-full h-8"></div>
          <div className="bg-slate-200 animate-pulse w-full h-8"></div>
        </div>
      </div>
      <div className="border p-3 rounded-lg">
        <div>
          <div className="py-2 font-bold text-sm text-[#2155ad] capitalize bg-gradient-to-t from-blue-500 to-blue-900 bg-clip-text text-transparent">
            <div className="bg-slate-200 animate-pulse w-20 h-5"></div>
          </div>
        </div>
        <div className="flex justify-start items-center gap-3">
          <div className="bg-slate-200 animate-pulse w-8 h-6"></div>
          <div className="bg-slate-200 animate-pulse w-8 h-6"></div>
          <div className="bg-slate-200 animate-pulse w-8 h-6"></div>
          <div className="bg-slate-200 animate-pulse w-8 h-6"></div>
          <div className="bg-slate-200 animate-pulse w-8 h-6"></div>
        </div>
      </div>
      <div className="border p-3 rounded-lg">
        <div>
          <div className="py-2 font-bold text-sm text-[#2155ad] capitalize bg-gradient-to-t from-blue-500 to-blue-900 bg-clip-text text-transparent">
            <div className="bg-slate-200 animate-pulse w-20 h-5"></div>
          </div>
        </div>
        <div className="space-y-3">
          <div className="bg-slate-200 animate-pulse w-16 h-3"></div>
          <div className="bg-slate-200 animate-pulse w-16 h-3"></div>
          <div className="bg-slate-200 animate-pulse w-16 h-3"></div>
          <div className="bg-slate-200 animate-pulse w-16 h-3"></div>
        </div>
      </div>
      <div className="border p-3 rounded-lg">
        <div>
          <div className="py-2 font-bold text-sm text-[#2155ad] capitalize bg-gradient-to-t from-blue-500 to-blue-900 bg-clip-text text-transparent">
            <div className="bg-slate-200 animate-pulse w-20 h-5"></div>
          </div>
        </div>
        <div className="space-y-3">
          <div className="bg-slate-200 animate-pulse w-16 h-3"></div>
          <div className="bg-slate-200 animate-pulse w-16 h-3"></div>
          <div className="bg-slate-200 animate-pulse w-16 h-3"></div>
          <div className="bg-slate-200 animate-pulse w-16 h-3"></div>
        </div>
      </div>
      <div className="border p-3 rounded-lg">
        <div>
          <div className="py-2 font-bold text-sm text-[#2155ad] capitalize bg-gradient-to-t from-blue-500 to-blue-900 bg-clip-text text-transparent">
            <div className="bg-slate-200 animate-pulse w-20 h-5"></div>
          </div>
        </div>
        <div className="space-y-3">
          <div className="bg-slate-200 animate-pulse w-16 h-3"></div>
          <div className="bg-slate-200 animate-pulse w-16 h-3"></div>
          <div className="bg-slate-200 animate-pulse w-16 h-3"></div>
          <div className="bg-slate-200 animate-pulse w-16 h-3"></div>
        </div>
      </div>
    </div>
  );
};

export default FilterLoading;
